import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Data.Controller.LiveCameraExt = (function(){

  function getString(buffer, start, length) {
    var outstr = "";
    for ( var n = start; n < start+length; n++ )
      outstr += String.fromCharCode(buffer.getUint8(n));
    return outstr;
  }

  function readString(file, tiffStart, dirStart, tag, big) {
    var entries = file.getUint16(dirStart, !big);
    for ( var i = 0 ; i < entries ; i++ ) {
      var entryOffset = dirStart+i*12+2;
      var t = file.getUint16(entryOffset, !big);
      if ( t == tag ) {
        var numValues = file.getUint32(entryOffset+4, !big);
        var valueOffset = file.getUint32(entryOffset+8, !big) + tiffStart;
        var offset = numValues > 4 ? valueOffset : (entryOffset + 8);
        return getString(file, offset, numValues-1);
      }
    }
  }

  function readLong(file, tiffStart, dirStart, tag, big) {
    var entries = file.getUint16(dirStart, !big);
    for ( var i = 0 ; i < entries ; i++ ) {
      var entryOffset = dirStart+i*12+2;
      var t = file.getUint16(entryOffset, !big);
      if ( t == tag )
        return file.getUint32(entryOffset+8,!big);
    }
  }

  return {
    setup: function(data) {
      data.control = {
        state: {
          retained:{},
          status:null,
          revision:0
        }
      };
      data._update('data', data.control.state)
      setTimeout(function() {
        data._inspector(data.source.data);
      }, 0);

      // コンフィグの調整
      data.setAutoUpdate('data', false);
      data.setUpdateInterval('data', 0);
      // 自動更新時間の優先度（CameraMaster > CameraInfo）
      var update_interval;
      if ( data.conf.CameraMaster && data.conf.CameraMaster.update_interval ) {
        data.setAutoUpdate('CameraMaster', false);
        update_interval = data.conf.CameraMaster.update_interval;
        data.control.auto_update_master = true;
      }
      if ( update_interval )
        data.setUpdateInterval('data', update_interval);
      if ( data.conf.CameraInfo && data.conf.CameraInfo.update_interval ) {
        //camera_info_update_interval = data.conf.CameraInfo.update_interval;
        data.setAutoUpdate('CameraInfo', false);
      }
      // timeout
      if ( data.controller_conf.request_timeout ) {
        var target = ["CameraMaster", "CameraInfo", "ImageFileList", "LatestImageFile", "ImageFile"];
        for ( var i = 0 ; i < target.length ; i++ ) {
          var ds = data.source[target[i]];
          if ( ds && ds.conf.request_timeout === undefined )
            ds.conf.request_timeout = data.controller_conf.request_timeout;
        }
      }
    },

    load: function(data, id, option, force, completed, error, progress) {
      if ( id == 'LatestImageFile' && data.source.Thumbnail ) {
        var dst = data.source.Thumbnail;
        dst.load(option, force,
          function(arrayBuffer) {

            var DateTimeOriginal = (function(file){
              var dv = new DataView(file);
              var offset = 0;
              if ((dv.getUint8(offset++)==0xFF)&&(dv.getUint8(offset++)==0xD8)) {   // JPEG
                var length = file.byteLength;
                while (offset < length) {
                  if (dv.getUint8(offset)==0xFF) {
                    var marker = dv.getUint8(offset+1);
                    if (marker == 225) {
                      var start = offset+4;
                      if ( getString(dv, start, 4) == 'Exif' ) {
                        var tiffOffset = start+6;
                        var endian = dv.getUint16(tiffOffset);
                        var big = (endian==0x4D4D); // 0x4949 or 0x4D4D
                        if (dv.getUint16(tiffOffset+2, !big) == 0x002A) { // validd tiff
                          var firstIFDOffset = dv.getUint32(tiffOffset+4, !big);
                          var ExifIFDPointer = readLong(dv, tiffOffset, tiffOffset+firstIFDOffset, 34665, big);
                          return readString(dv, tiffOffset, tiffOffset+ExifIFDPointer, 36867, big);  // DateTimeOriginal
                        }
                      }
                    }
                    else {
                      offset += 2+dv.getUint16(offset+2);
                    }
                  }
                }
              }
            })(arrayBuffer);
            //console.log(DateTimeOriginal);
            var image = new Image();
            var bytes = new Uint8Array(arrayBuffer);
            var binaryData = "";
            for (var i = 0, len = bytes.byteLength; i < len; i++) {
              binaryData += String.fromCharCode(bytes[i]);
            }
            image.src = "data:image/jpeg;base64," + window.btoa(binaryData);
            DateTimeOriginal = DateTimeOriginal.replace(/:/g, '').replace(/ /g, '');
            completed({
              time:DateTimeOriginal,
              image:image
            });
          },
          error, progress);
        return;
      }
      var ds = data.source[id];
      if ( ds ) {
        return ds.load(option, force, completed, error, progress);
      }
      else {
        if ( id == 'LatestImageFile' && data.source.ImageFileList ) {
          ds = data.source.ImageFileList;
          var t = new WRAP.Core.currentTime();
          var time_end = t.text('YYYYMMDDhhmmss');
          t.add(-3600*10);  // 10hour
          var time_start = t.text('YYYYMMDDhhmmss');
          var opt = {
            id:option.id,
            baseUrl: option.camerapath,
            camerapath:option.camerapath,
            time_start: time_start,
            time_end: time_end
          }
          ds.load(opt, force,
            function(files) {
              if ( files && files.keys ) {
                files.keys.sort(function(a,b) {
                  if ( a > b ) return -1;
                  if ( a < b ) return 1;
                  return 0;
                });
                completed(files.keys[0]);
              }
            }, error, progress);
        }
      }
    },

    derive: function(data, id, option, force, completed) {
      force;  // unused
      data.load('CameraMaster', option, true,
        async function(camera_master_data) {
//                    update('CameraMasterResponse', null, {});
          var base = data.control.state.retained = {};
          // var master = camera_master_data.split("\n");
          // for ( var i = 0 ; i < master.length ; i++ ) {
          //   var camera = master[i];
          //   if ( camera.length ) {
          //     var cameraelems = camera.split(',');
          //     if (cameraelems.length > 1)
          //       camera = cameraelems[0];
          //     var m = base[camera] || (base[camera]={});
          //     m.camerapath = 'public';
          //     if (cameraelems.length > 1)
          //       m.camerapath = cameraelems[1];
          //     m.controller = data;
          //   }
          // }
          const map = new Map();
          camera_master_data.selectable_list.forEach(c => {
            if (!c.nodisplay_flag) {
              map.set(c.area, c);
            }
          });
          camera_master_data.select_list.forEach(c => {
            //selectable_listにないけどselect_listにあるものはskip
            if (!map.has(c.area)) {
              return;
            }
            const m = base[c.area] || (base[c.area]={});
            m.camerapath = map.get(c.area).category;
            m.controller = data;
            m.config = {...map.get(c.area)};
          });
          data._update(id, data.control.state)
          if ( completed )
            completed(base);
          var target = data.source[id];
          data._inspector(target);
          for ( var i = 0 ; i < target.inspector.completed.length ; i++ )
            target.inspector.completed[i](data.retained[id]);
          target.autoUpdate();
        },
        function(info, url) {
          info, url;  // unused
        });
    },

    // disable external auto-update control
    setAutoUpdate: function() {},

    setUpdateInterval: function() {}

  }
}());
/* eslint-enable */